import { ReactNode } from "react";

interface FilterToggleProps {
    label: string;
    count: number | string;
    className?: string;
    children?: ReactNode;
    panelWidth: number | string;
}

const FilterToggleTopic = ({ label, count, children, panelWidth }: FilterToggleProps) => {

    const shouldShowCounter = typeof count === "number" && count > 0;
    const filterButtonTopicClasses = `filter-btn-topic leading-5 ${panelWidth} ${
        shouldShowCounter ? "has-counter" : ""
    }`;

    return (
        <div className="filter-toggle">
            <div
            className={filterButtonTopicClasses}
            >
                {label}
            </div>   
                {children}
        </div>
    );
};

export default FilterToggleTopic;
